import { render, staticRenderFns } from "./inlineLoader.vue?vue&type=template&id=5663dc5a&scoped=true&"
import script from "./inlineLoader.vue?vue&type=script&lang=js&"
export * from "./inlineLoader.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./inlineLoader.vue?vue&type=style&index=0&id=5663dc5a&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5663dc5a",
  null
  ,true
)

export default component.exports